"use client";

import { c as _c } from "react/compiler-runtime";
import { useEmailComposer } from "../../context";
import { LuMoreHorizontal } from "react-icons/lu";
import { Button } from "@/components/ui";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { AIButton } from "./ai-button";
import { AttachmentButton } from "./attachment-button";
import { ClearFormattingButton } from "./clear-formatting-button";
import { FontFamilySelect } from "./font-family-select";
import { FontSizeSelect } from "./font-size-select";
import { HSeparator } from "./h-separator";
import { HeadingDropdown } from "./heading-dropdown";
import { ImageInsertButton } from "./image-insert-button";
import { LinkButton } from "./link-button";
import { StrikethroughButton } from "./strikethrough-button";
import { TextColorButton } from "./text-color-button";

/** "More" button visible only on mobile — opens a popover with secondary actions. */
export function OverflowMenu() {
  const $ = _c(18);
  const {
    onImageUpload,
    onAddFiles,
    onAI
  } = useEmailComposer();
  const hasMediaButtons = onImageUpload || onAddFiles;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PopoverTrigger asChild={true}><Button type="button" variant="ghost" size="icon-sm" tooltip="More formatting"><LuMoreHorizontal size={16} /></Button></PopoverTrigger>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LinkButton />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hasMediaButtons || $[3] !== onAddFiles || $[4] !== onImageUpload) {
    t2 = hasMediaButtons && <>{onImageUpload && <ImageInsertButton />}{onAddFiles && <AttachmentButton />}</>;
    $[2] = hasMediaButtons;
    $[3] = onAddFiles;
    $[4] = onImageUpload;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <HSeparator />;
    t4 = <HeadingDropdown />;
    t5 = <FontFamilySelect />;
    t6 = <FontSizeSelect />;
    t7 = <TextColorButton />;
    t8 = <StrikethroughButton />;
    t9 = <ClearFormattingButton />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t10;
  if ($[13] !== onAI) {
    t10 = onAI && <><HSeparator /><AIButton /></>;
    $[13] = onAI;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t2) {
    t11 = <Popover>{t0}<PopoverContent className="flex items-center gap-0.5 w-fit min-w-0 p-1">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</PopoverContent></Popover>;
    $[15] = t10;
    $[16] = t2;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}